module.exports = __webpack_public_path__ + "img/cargo-care-logo.2652d191.png";